import { Preference } from './../../../../avisDePub/preferences-avis-de-pub/model/preference';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/simp_in/step3';
import { PreferenceType } from '../../../../shared/models/enum/preferenceType';
import { TypeCPVClass } from '../models/TypeCPVClass';
@Component({
  selector: 'app-typeCPV-class',
  templateUrl: './typeCPV-class.component.html'
})
export class TypeCPVClassComponent implements OnInit {
  @Input() uid = '';
  public current_uid = 'TypeCPVClass';
  @Input() parentForm: FormGroup;

  @Input() disabled: boolean;
  @Input() objetPrincipal: TypeCPVClass;

  @Input() i = -1;

  @Output() prefEmit: EventEmitter<Preference> = new EventEmitter();

  displayStar = true;

  public step3 = new Step3();

  public typeCpv = PreferenceType.CODES_CPV;

  constructor() {
  }

  public ngOnInit() {
    if (this.i > 0) {
      this.displayStar = false;
    }
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  chargeDonneePreference(preference: Preference) {
    if (this.i === undefined) {
      this.parentForm.get(this.getUid() + '_SepAtt_classPrincipale')?.setValue(preference?.content?.values[0]?.code);
      this.parentForm.get(this.getUid() + '_SepAtt_classPrincipale')?.markAsTouched();
    }
    else {
      this.prefEmit.emit(preference);
    }
  }

}
